<template>
	<div class="columns is-hidden-mobile">
		<div class="column is-half">
			<div class="subtitle">Alternate Schedules</div>

			<div class="box">
				<table class="table is-fullwidth">
					<thead>
						<tr>
							<th class="has-text-right">#</th>
							<th>Team Schedule</th>
							<th title="Strength of Schedule" class="has-text-right">
								<span class="title-text">SOS</span>
							</th>
							<th class="has-text-centered">Record</th>
							<th class="has-text-centered" v-if="page.has_divisions">Division</th>
							<th></th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="alternate_schedule in page.alternate_schedules">
							<td class="has-text-right">{{ alternate_schedule.standing_rank }}</td>
							<td><TeamLink :teamKey="alternate_schedule.team_key" :teamName="alternate_schedule.team_name" /></td>
							<td class="has-text-right">{{ alternate_schedule.strength_of_schedule }}</td>
							<td class="has-text-centered">{{ alternate_schedule.record }}</td>
							<td class="has-text-centered" v-if="alternate_schedule.division_record">
								{{ alternate_schedule.division_record }}
							</td>
							<td>
								<a
									href="#"
									class="effect has-text-weight-semibold"
									@click.prevent="setActiveAlternateSchedule(alternate_schedule.team_key)"
									><small>Details</small></a
								>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>

		<div class="column is-half" v-if="focused_alternate_schedule">
			<div class="subtitle">
				<TeamLink :teamKey="focused_alternate_schedule.team_key" :teamName="focused_alternate_schedule.team_name" /> Schedule
			</div>

			<div class="box">
				<table class="table is-fullwidth">
					<thead>
						<tr>
							<th class="has-text-right">Week</th>
							<th colspan="2" class="has-text-centered">Points Scored</th>
							<th>Opponent</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="item in focused_alternate_schedule.schedule">
							<td class="has-text-right">{{ item.week_id }}</td>
							<td class="has-text-right" :class="{ 'has-text-weight-bold': item.is_winner, 'is-italic': !item.is_complete }">
								{{ item.team1_points }}
							</td>
							<td :class="{ 'has-text-weight-bold': item.is_loser, 'is-italic': !item.is_complete }">
								{{ item.team2_points }}
							</td>
							<td>
								<TeamLink :teamKey="item.team2_key" :teamName="item.team2_name" />
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</div>
</template>

<script>
import TeamLink from "./TeamLink"

export default {
	props: ["page"],
	components: {
		TeamLink,
	},
	computed: {
		focused_alternate_schedule() {
			return this.$store.getters.activePageAlternateSchedule
		},
	},
	methods: {
		setActiveAlternateSchedule(teamKey) {
			this.$store.dispatch("setActivePageAlternateScheduleTeamKey", teamKey)
		},
	},
	mounted() {
		this.setActiveAlternateSchedule("")
	},
}
</script>

<style scoped></style>
